define("CCAW.FloatingContactUs.Modal.View", [
    "SCView",
    "jQuery",
    "underscore",
    "ccaw_floating_contact_us_modal.tpl",
], function (
    SCViewModule,
    jQuery,
    _,
    ccaw_floating_contact_us_modal_tpl
) {
    "use strict";

    var SCView = SCViewModule.SCView;

    function CCAWFloatingContactUsModalView(options) {
        SCView.call(this);

        this.options = options || {};
        this.config = this.options.config || {};
        this.template = ccaw_floating_contact_us_modal_tpl;
        this.page_header = this.options.pageHeader || this.config.modalTitle;
        this.modalClass = "global-views-modal-large ccaw-floating-contact-us-modal";
    }

    CCAWFloatingContactUsModalView.prototype = Object.create(SCView.prototype);
    CCAWFloatingContactUsModalView.prototype.constructor = CCAWFloatingContactUsModalView;

    CCAWFloatingContactUsModalView.prototype.loadJotformForm = function loadJotformForm() {
        var self = this;
        var scriptUrl = this.config.jotformScriptUrl;
        var containerEl = this.$(".jotform-frame__render").get(0);
        var script;

        if (!scriptUrl) {
            this.showConfigurationMessage();
            return;
        }

        if (!containerEl) {
            return;
        }

        this.clearMessage();
        containerEl.innerHTML = "";

        script = document.createElement("script");
        script.type = "text/javascript";
        script.src = scriptUrl;
        script.onerror = function onerror() {
            self.showErrorMessage();
        };

        containerEl.appendChild(script);
    };

    CCAWFloatingContactUsModalView.prototype.showConfigurationMessage = function showConfigurationMessage() {
        this.$('[data-type="jotform-status"]').removeClass("hidden").text(
            "Set the JotForm form ID in CCAW Floating Contact Us configuration."
        );
    };

    CCAWFloatingContactUsModalView.prototype.showErrorMessage = function showErrorMessage() {
        this.$('[data-type="jotform-status"]').removeClass("hidden").text(
            "The contact form could not be loaded right now."
        );
    };

    CCAWFloatingContactUsModalView.prototype.clearMessage = function clearMessage() {
        this.$('[data-type="jotform-status"]').addClass("hidden").empty();
    };

    CCAWFloatingContactUsModalView.prototype.getContext = function getContext() {
        return {
            hasJotformConfig: !!this.config.jotformScriptUrl,
        };
    };

    return CCAWFloatingContactUsModalView;
});
